export {};
//# sourceMappingURL=customAnimationFrameRequester.js.map